package com.esoris.kmpmoout.features.expense.expense_form

import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val expenseFormModule = module {

    viewModelOf(::ExpenseFormViewModel)

}